/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const customerEntityService = {
  getList: (params: any) => request.get('/dc/charterer-entity', { params }),
  getByIdChartererLimit: (id: any) => request.get(`/charterer-limit/${id}`),
  getById: (id: string) => request.get(`/legal-entity/${id}`),
  getByIdCheckChartererLimit: (
    provider_id: any,
    charterer_id: string,
    params: any
  ) =>
    request.get(`/check-charterer-limit/${provider_id}/${charterer_id}`, {
      params
    }),
  getListCheck: (params: any) => request.get('/dc/charterer/check', { params }),
  getListHistorySettlement: (params: any) =>
    request.get('/dc/settlement', { params }),
  getListCountPlan: (params: any) =>
    request.get('dc/proposed/settlement/count', { params }),
  getListApplications: (params: any) =>
    request.get('/order/notification', { params }),

  createRoleBackSettlement: (data: any) =>
    request.post('/dc/settlement/rollback', data),

  createLegalEntityRelation: (data: any) =>
    request.post('/legal-entity/relation', data),

  createCustomerSettelment: (data: any) =>
    request.post('/dc/customer/settlement', data),
  createCharterer: (data: any) => request.post('/dc/charterer', data),

  createChartererLimit: (data: any) => request.post('/charterer-limit', data),

  getListCharterer: (params: any) => request.get('/dc/charterer', { params }),
  getCustomerSettlementById: (id: string, params: any) =>
    request.get(`/dc/settlement/${id}`, { params }),
  getSettlementProviderById: (id: string, params: any) =>
    request.get(`/dc/settlement-provider/${id}`, { params }),

  getSettlementChartererById: (id: string, params: any) =>
    request.get(`/dc/settlement-charterer/${id}`, { params }),

  updateCustomerSettlement: (id: any, data: any) =>
    request.put(`/dc/settlement/${id}`, data),
  updateChartererLimit: (id: any, data: any) =>
    request.put(`/charterer-limit/${id}`, data),

  deleteChartererLimit: (id: any) => request.delete(`/charterer-limit/${id}`),
  getChartererListExcel: (params: any) =>
    request.get('/report/dc/charterer/excel', { params }),

  updateProposalCreditor: (id: any, data: any) =>
    request.put(`/dc/proposed/creditor/${id}`, data),
  updateProposalDebitor: (id: any, data: any) =>
    request.put(`/dc/proposed/debitor/${id}`, data),
  getListProposalChartererIn: (params: any) =>
    request.get('/dc/proposed/charterer-in', { params }),
  getListProposalChartererOut: (params: any) =>
    request.get('/dc/proposed/charterer-out', { params }),
  getListProposalProviderIn: (params: any) =>
    request.get('/dc/proposed/provider-in', { params }),
  getListProposalProviderOut: (params: any) =>
    request.get('/dc/proposed/provider-out', { params })
};

export default customerEntityService;
